import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function ForexBrokerageVincentGrenadines (){

    return (
        <main className='main'>

            <IntroSection
                title="Forex & Brokerage – St. Vincent & the Grenadines"
                subtitle="Fast & Flexible Offshore Base for Forex and CFD Brokers"
                description =
                    "
                        St. Vincent & the Grenadines (<b>SVG</b>) has become one of the <b>most popular jurisdictions in the world for forex and brokerage firms</b>.
                        <br/>
                        While <b>SVG does not issue dedicated forex licenses</b>, brokers operate through <b>IBC structures</b>, which provide <b>low-cost entry, fast setup, and maximum flexibility</b>.
                    "
                badges={
                    [
                        "Forex Brokers",
                        "CFD Platforms",
                        "Crypto Brokers",
                        "Offshore IBCs"
                    ]
                }
                buttonText="Request a St. Vincent Brokerage Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/forex-brokerage-St-vincent-grenadines-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose SVG for Forex?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Fast Setup",
                                            text: "IBCs can be incorporated in 1–2 weeks."
                                        },
                                        {
                                            title: "No Capital Requirements",
                                            text: "Unlike Mauritius or Cyprus."
                                        },
                                        {
                                            title: "Low Cost",
                                            text: "Among the cheapest forex-friendly jurisdictions."
                                        },
                                        {
                                            title: "Flexible Operations",
                                            text: "Covers forex, CFDs, and crypto."
                                        },
                                        {
                                            title: "Popular Choice",
                                            text: "Used by thousands of global brokers."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Features of SVG Brokerage Setup"
                        blocks={[
                            {
                                items:
                                    [
                                        { text: "Structure: International Business Company (IBC)." },
                                        { text: "Scope: forex, CFD, crypto, and multi-asset trading possible." },
                                        { text: "AML/KYC: not enforced by regulator, but recommended for credibility." },
                                        { text: "Banking: offshore banking or PSPs must be arranged outside SVG." },
                                        { text: "Regulation: brokers are not licensed but operate legally as IBCs." }
                                    ]
                            },
                        ]}
                    />

                    <LocationTimeline
                        title="Benefits of SVG Brokerage Companies"
                        item={
                            [
                                {
                                    title: "Quick Entry",
                                    text: "Ideal for startups and small firms."
                                },
                                {
                                    title: "Low-Cost Incorporation",
                                    text: "No capital or compliance hurdles."
                                },
                                {
                                    title: "Flexibility",
                                    text: "Brokers can run forex and crypto under one entity."
                                },
                                {
                                    title: "Scalable",
                                    text: "Easy to expand operations internationally."
                                },
                                {
                                    title: "Privacy",
                                    text: "Minimal disclosure obligations."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Limitations of SVG Brokerage'
                        services={
                            [
                                {
                                    title: "No Investor Protection",
                                    text: "Unlike CySEC, FCA, ASIC, or Mauritius."
                                },
                                {
                                    title: "Banking Challenges",
                                    text: "Many banks are reluctant to serve SVG brokers."
                                },
                                {
                                    title: "High-Risk Label",
                                    text: "PSPs and regulators often flag SVG brokers."
                                },
                                {
                                    title: "Not Institutional-Grade",
                                    text: "Unsuitable for large investors."
                                }
                            ]
                        }
                        />

                    <FeatureCards
                        title='Licensing Process (IBC Incorporation)'
                        features={
                            [
                                { text: "Pre-Application Consultation — define brokerage model." },
                                { text: "Company Incorporation — SVG IBC formed within 1–2 weeks." },
                                { text: "Corporate Documents Issued — including Certificate of Incorporation, Articles." },
                                { text: "Banking/PSP Setup — Offshore Advisory connects with offshore banks/PSPs." },
                                { text: "Operational Launch — broker begins onboarding clients." }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "1-2 weeks for IBC Incorporation",
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 3,000+",
                            },
                            {
                                name: "Annual Costs",
                                description: "registered agent + renewal fees",
                            },

                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in forex & brokerage structures worldwide." },
                                { text: "Integration with offshore banking, PSPs, and payment providers." },
                                { text: "Assistance with upgrading from SVG to Tier-1 licenses (e.g., Mauritius, Cyprus, Malta)." },
                                { text: "Compliance frameworks for brokers seeking higher credibility." },
                                { text: "Long-term support for scaling & expansion." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Looking to launch a forex or CFD brokerage quickly and affordably?
                             "
                         description=
                             "
                                St. Vincent offers IBC structures with minimal barriers, making it ideal for startups and high-risk operators.
                             "
                         buttonText='Book a St. Vincent Forex Setup Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Does SVG issue a forex license?",
        content: [
            { type: "answer", text: "No — brokers register as IBCs without regulatory supervision." },
        ],
    },
    {
        question: "Why do brokers still use SVG?",
        content: [
            { type: "answer", text: "Low cost, fast setup, and flexibility." },
        ],
    },
    {
        question: "Can SVG brokers open bank accounts?",
        content: [
            { type: "answer", text: "Yes — but usually with offshore banks or fintech PSPs outside SVG." },
        ],
    },
    {
        question: "Is SVG recognized by investors?",
        content: [
            { type: "answer", text: "No — institutional clients prefer regulated hubs (Cyprus, FCA UK, ASIC, Mauritius)." },
        ],
    },
    {
        question: "Can SVG brokers offer crypto trading?",
        content: [
            { type: "answer", text: "Yes — IBCs can legally run crypto exchanges and hybrid brokerages." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We launched our forex brokerage as an SVG IBC. Offshore Advisory provided incorporation and PSP solutions.",
            author: "Karim S.",
            role: "Brokerage Founder"
        },
        {
            quote: "SVG was a quick start for our CFD platform. Offshore Advisory later helped us expand into Mauritius.",
            author: "Elena P.",
            role: "Trading Firm CEO"
        }
    ]
;